import React, { useEffect, useState, useRef } from "react"
import styled, { keyframes } from "styled-components"

import { Menu, fadeInUp } from "../Menu/Menu"
import { MenuSeparator } from "../Menu/MenuSeparator"
import loadingGif from "../../images/spinner.gif"
import URLLogo from "../../images/velkomin-a-Fjarhátíð-Marel.png"
import ConceptLogo from '../../images/CE_LOGO_hvitt.png'
import useFirebase from "../../../useFirebase"

import {
  regex_email,
} from "../../utils/validation/registerValidate";
import { MyLocationEnum } from "../Layout"
import { number_size, mediaMax } from "../../utils/breakpoints"
import BackgroundVideo from "../../images/Forsidu-loopa-4.mp4"

import Img from 'gatsby-image';

export const fadeOut = () => keyframes`
	0% {
	  opacity: 1;
	}
  
	100% {
	  opacity: 0;
	}

`

interface LobbyProps {
  show: boolean
  myLocation?: MyLocationEnum
  onCloseLobby: () => void
  zIndex?: number | string
}

export default ({ show, myLocation, onCloseLobby }: LobbyProps) => {
  const firebase = useFirebase();
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const [userEmail, setUserEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [LoginErrors, setLoginErrors] = useState("");
  const [superError, setSuperError] = useState("");
  const [spinnerActive, setSpinnerActive] = useState(false);
  const [BrowserSupport, setBrowserSupport] = useState(true);

  useEffect(() => {
    if (
      typeof window != "undefined" &&
      localStorage.getItem("loggedIn") !== null
    ) {
      setIsLoggedIn(true)
    } else {
      setIsLoggedIn(false)
    }

    const checkBrowser = () => {
      /* Internet explorer */
      const isIE = (/*@cc_on!@*/ false || !!document.documentMode)
      if(isIE){setBrowserSupport(false)};

      // Edge 20+
      var isEdge = !isIE && !!window.StyleMedia;
      if(isEdge){setBrowserSupport(false)};
    }

    checkBrowser();
  }, [])

  

  const getUser = (userEmail: string) => {
    setSpinnerActive(true)

    const emailLowerCase = userEmail.toLowerCase();

    if (!regex_email.test(String(userEmail).toLowerCase())) {
      setLoginErrors("*Ógilt netfang")
      setSpinnerActive(false)
    }
    // TODO: setTimeout not clear... resulting in empty page with nothing.
    // Breaks layout
    else if (firebase != null) {
      firebase
        .database()
        .ref("/")
        .child("users")
        .orderByChild("email")
        .equalTo(emailLowerCase)
        .on("value", function (snapshot) {
          if (snapshot.val() != null) {
            snapshot.forEach(function (data) {
              if (data.val().email != "" && typeof window !== undefined) {
                try {
                  (window as any).dataLayer = (window as any).dataLayer || []
                  (window as any).dataLayer.push({
                    event: "buttonClick",
                    category: "marel arshatid",
                    action: "innskraning",
                    label: "success",
                  })
                } catch {
                }

                setTimeout(() => {
                  localStorage.setItem("loggedIn", userName + " (" + userEmail + ")");
                  setIsLoggedIn(true);
                  setSpinnerActive(false);
                }, 1000)
                
              } else {
                setLoginErrors("Notandi finnst ekki")
                setSpinnerActive(false)
              }
            })
          } else {
            setLoginErrors("Notandi finnst ekki")
            setSpinnerActive(false)
          }
        })
    }
  }

  // Playing the video when not needed takes up resources.
  const videoRef = useRef<HTMLVideoElement>(null)
  useEffect(() => {
    if (typeof window === "undefined" || videoRef.current === null) {
      return
    }

    try {
      if (!show) {
        const p = videoRef.current.pause()
        // p.catch(() => {})
      } else {
        const p = videoRef.current.play()
        p.catch(() => {
          
        })
      }
    } catch { }

  }, [show])

  if (isLoggedIn == null) {
    return <div></div>
  } else {
    return (
      <Background className={show ? "show" : ""}>

        <ConceptLogoImage src={ConceptLogo} alt="logo concept" />
        
         <StyledVideo autoPlay muted loop ref={videoRef} browserSupport={BrowserSupport}>
          <source src={BackgroundVideo} type="video/mp4" />
        </StyledVideo>
        
        <Content>
          <StyledIcon>
            <img src={URLLogo} alt="logo marel" />
          </StyledIcon>
          {isLoggedIn ? (
            <SeparatorContainer>
              <MenuSeparator
                title="VELKOMIN"
                width="48%"
                showColor={true}
                lineColor="#F7D00E"
                showInMobile={false}
                isButton={false}
              >
                <MenuText>
                Vertu velkomin/n í Fjarhöll Marel.
                <br/>
                Við ætlum að skemmta okkur saman - heima í stofu.
                <br/><br/>
                Við hvetjum ykkur til að taka þátt með því að senda okkur kveðjur, komment og óskalög í kommentakerfinu; SLIDO og í spjallinu inn í Fordrykk.
                <br/><br/>
                Vafraðu um í höllinni, upplifðu og hittu vinnufélagana.
                </MenuText>
              </MenuSeparator>

              <MenuSeparator
                title="VALMYND"
                width="48%"
                showColor={true}
                lineColor="#F7D00E"
                showInMobile={true}
                isButton={false}
              >
                <Menu myLocation={myLocation} onSameSiteClick={onCloseLobby} />
              </MenuSeparator>
            </SeparatorContainer>
          ) : (
            <SeparatorContainer>
              <MenuSeparator
                title="VELKOMIN"
                width="48%"
                showColor={true}
                lineColor="#F7D00E"
                showInMobile={false}
                isButton={false}
              >
                <MenuText>
                  Vinsamlegast skráðu þig inn hér til hægri til að fá aðgang að árshátíðinni.
                </MenuText>
              </MenuSeparator>

              <MenuSeparator
                title="INNSKRÁ"
                width="48%"
                showColor={true}
                lineColor="#F7D00E"
                isButton={true}
                showInMobile={true}
              ></MenuSeparator>

              <FormContent
                className={"active"}
                width="48%"
                onSubmit={(e: any) => {
                  e.preventDefault()
                }}
              >

                {superError != "" && (
                  <StyledErrorContainer>
                    <div className="message">{superError}</div>
                  </StyledErrorContainer>
                )}
                <StyledInput
                  type="nafn"
                  placeholder="Nafn"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setUserName(e.target.value)
                  }
                />
                <StyledInput
                  type="email"
                  placeholder="Netfang"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setUserEmail(e.target.value)
                  }
                />
                <StyledButton onClick={() => getUser(userEmail)}>
                  <StyledSpinner
                    className={spinnerActive ? "active" : ""}
                    src={loadingGif}
                    alt="spinner"
                    aria-hidden="true"
                  />
                  <ButtonText className={spinnerActive ? "hidden" : ""}>
                    Innskrá
                  </ButtonText>
                </StyledButton>
                {LoginErrors != "" && (
                  <StyledErrorContainer>
                    <div className="message">{LoginErrors}</div>
                  </StyledErrorContainer>
                )}
              </FormContent>
            </SeparatorContainer>
          )}
        </Content>
      </Background>
    )
  }
}

const ConceptLogoImage = styled.img`
  position: absolute;
  bottom: 20px;
  right: 20px;
  z-index: 20;
  height: 70px;
`

const StyledErrorContainer = styled.div`
  display: flex;
  padding: 1em 0 0 1.25em;

  .message {
    font-family: ${({ theme }) => theme.fonts.fontFamilySecondary};
    display: flex;
    flex-direction: column;
    letter-spacing: 0;
    font-size: 1.2em;
    line-height: 1.43em;
    color: red;
    text-align: right;
    flex: 1;
  }
`

const StyledSpinner = styled.img`
  display: none;
  height: 40px;
  width: 40px;

  &.active {
    display: block;
  }
`

const ButtonText = styled.span`
  display: block;

  &.hidden {
    display: none;
  }
`

const StyledButton = styled.button`
  height: 45px;
  width: 100%;
  border-radius: 22.5px;
  background: linear-gradient(90deg, rgba(42,181,177,1) 13%, rgba(0,61,128,1) 58%);
  color: #ffffff;
  font-family: ${({ theme }) => theme.fonts.fontFamilySecondary};
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 28px;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  &:focus {
    outline: none;
  }
`

const StyledInput = styled.input`
  width: 100%;
  height: 45px;
  border-radius: 22.5px;
  background-color: #ffffff;
  margin-bottom: 10px;
  border: none;
  padding-left: 20px;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 26px;
  padding-top: 2px;
  font-family: ${({ theme }) => theme.fonts.fontFamilySecondary};

  &:focus {
    outline: none;
  }

  ::-webkit-input-placeholder {
    /* Edge */
    color: #808080;
    font-family: ${({ theme }) => theme.fonts.fontFamilySecondary};
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #808080;
    font-family: ${({ theme }) => theme.fonts.fontFamilySecondary};
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
  }

  ::placeholder {
    color: #808080;
    font-family: ${({ theme }) => theme.fonts.fontFamilySecondary};
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
  }
`

const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;

  pointer-events: none;
  opacity: 0;
  z-index: 0;
  /* transition: opacity 0.355s cubic-bezier(0.8, 0, 0.07, 1), z-index .2s 1s; */
  transition: z-index 0.5s step-end, opacity 0.5s cubic-bezier(0.8, 0, 0.07, 1);

  @media (max-width: ${number_size.mobileL}) {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
  }

  &.show {
    pointer-events: auto;
    transition: z-index 0.5s step-start,
      opacity 0.5s cubic-bezier(0.8, 0, 0.07, 1);
    z-index: 200;
    opacity: 1;
  }
`

const StyledBackgroundImage = styled(Img)`
  height: 100%;
  width: 100%;
  position: absolute !important;
`

interface videoProps {
  browserSupport : boolean
}
const StyledVideo = styled.video<videoProps>`
  position: absolute;
  left: 0;
  top: 0;
  ${({browserSupport}) => {
    if(browserSupport){
      return`
        width:100%;
        height:100%;
      `
    }else{
      return`
        right:0;
        bottom:0;
      `
    }
  }}
  object-fit: cover;
  z-index: 10;
`

const StyledIcon = styled.div`
  width: 100%;
  margin-bottom: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  > img{
    width:60%;
    margin-left:-10%;

    @media(max-width:1400px){
      margin-left:0;
    }
  }

  h1 {
    font-family: ${({ theme }) => theme.fonts.fontFamilyPrimary};
    color: #fff;
    font-size: 32px;
  }


  @media ${mediaMax.tablet} {
    width: 100%;
  }
`

const MenuText = styled.div`
  color: #ffffff;
  font-family: ${({ theme }) => theme.fonts.fontFamilyPrimary};
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 30px;

  opacity: 0;
  animation: 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0.2s 1 normal forwards
    running ${fadeInUp};
`

const SeparatorContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  width: 100%;
`

interface FormContentProps {
  width?: string
}
const FormContent = styled.form<FormContentProps>`
  opacity: 0;
  position: absolute;
  right: 0;
  width: ${({ width }) => width};
  top: 50px;
  z-index: -1;
  transition: opacity 0.3s ease-in;

  &.active {
    transition: opacity 0.3s ease-in 0.3s;
    opacity: 1;
    z-index: 2;
  }

  @media ${mediaMax.mobileL} {
    width: 100%;
  }
`

const Content = styled.div`
  max-width: 1170px;
  width: 90vw;
  height: 80vh;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 30;

	@media ${mediaMax.tabletL} {
		margin-top:100px;
	}

  @media(max-width:500px){
    height: 50vh;
  }

`
